/**
 * Ids the citation highlighter searches in: the image description and the OCR text. Scoped per
 * document so multiple viewers don't clash.
 */
export const imageOcrContainerId = (documentId: string) => `image-ocr-text-${documentId}`;
export const imageDetailsContainerId = (documentId: string) => `image-details-text-${documentId}`;
